import { getKeysRecurse } from '@dokucoach/common-utils';
import Box from '@material-ui/core/Box';
import DayPlanner from 'components/DayPlanner';
import { RowHourClickProps } from 'components/DayPlanner/index.view';
import Popper, { MessageType } from 'components/Popper';
import RadioConditionGroup from 'components/RadioConditionGroup';
import { getIn, useFormikContext } from 'formik';
import React from 'react';
import Select from '../Select';

const makeAdaptDayPlannerField =
  <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  ({ form, field, editable, ...props }: any) => {
    return (
      <Component
        data={field.value}
        onChange={(v: RowHourClickProps) => {
          form.setFieldValue(field.name, v);
        }}
        disabled={!editable}
        {...props}
      />
    );
  };

const makeAdaptRadioField =
  <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  ({ form, field, editable, disabled, wrapper, ...props }: any) => {
    return (
      <Box sx={{ py: 1.25, ...wrapper }}>
        <Component
          {...field}
          {...props}
          disabled={!editable || disabled}
          suffix={
            form.errors[field.name] && (
              <Popper msg={form.errors[field.name]} type={MessageType.ERROR} className="pl-0" />
            )
          }
        />
      </Box>
    );
  };

const makeAdaptField =
  <P extends Record<string, unknown>>(Component: React.ComponentType<P>) =>
  ({
    form,
    field,
    editable,
    errorMessage,
    disabled,
    id,
    wrapper = {},
    disableError = false,
    ...props
  }: any) => {
    const { errors } = useFormikContext<any>();
    const errorFields = getKeysRecurse(errors);
    const hasErrors = errorFields.includes(field.name.split('.').reverse()[0]);
    const errorMsg = errorMessage ? errorMessage : getIn(errors, field.name);

    if (props.dropdownList && props.nullable) {
      props.dropdownList = ['-', ...props.dropdownList];
    }

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1.25,
          ...wrapper,
        }}
      >
        <Box
          sx={{
            flex: 1,
          }}
        >
          <Component {...props} {...field} disabled={!editable || disabled} id={id} />
        </Box>
        {!disableError && errorMsg && hasErrors && (
          <Popper
            id={`${field.name}-popper-svg`}
            type={MessageType.ERROR}
            msg={errorMsg}
            style={{
              paddingLeft: 6,
            }}
          />
        )}
      </Box>
    );
  };

export const AdaptDayPlannerField = makeAdaptDayPlannerField(DayPlanner);

export const AdaptRadioConditionGroupField = makeAdaptRadioField(RadioConditionGroup);

export const AdaptSelect = makeAdaptField(Select);
